import {
  computed, ref, watchEffect,
} from '@vue/composition-api'
import store from '@/store'

export default function useNewTable() {
  const refNewTable = ref(null)

  const tableColumns = [
    { key: 'id', label: 'ID', sortable: true },
    { key: 'modulo_name', label: 'Nome do Módulo', sortable: true },
    { key: 'modulo_ativo', label: 'Ativo', sortable: true },
  ]

  const perPage = ref(5)
  const totalRows = ref(0)
  const currentPage = ref(1)
  const moduloData = ref([])

  const fetchData = async () => {
    try {
      const response = await store.dispatch('ModuloTreStore/fetchModulosConteudo')
      moduloData.value = response.data
      refNewTable.value.rows = response.data
    } catch (error) {
      console.error(error)
    }
  }
  const moduloRefresh = computed(() => {
    return moduloData.value
  })

  const refetchData = async () => {
    await fetchData()
    refNewTable.value.refresh()
  }

  watchEffect(async () => {
    await fetchData()
  })

  return {
    tableColumns,
    perPage,
    totalRows,
    currentPage,
    refNewTable,
    moduloData,
    moduloRefresh,
    refetchData,
  }
}
